import * as TypesDemoclass from '../types/types_democlass';
import Vue from 'vue';

export default {
    state: {
        audit: '',
        contactParent: '',
        feedbackInfo: {}
    },
    getters: {},
    mutations: {
        [TypesDemoclass.DEMOCLASS_SAVE_INFO](state, payload) {
            ['audit', 'contactParent', 'feedbackInfo'].forEach(item => {
                state[item] = payload[item];
            });
        }
    },
    actions: {}
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_democlass.js